import Card from "@particles/card/Card";
import { CardVariations } from "@particles/card/utils/types";
import { transformMediaToFeedMedia } from "@routes/Keyword/templates/CampaignTemplate/utils/helper";
import { FeedVideosItemType } from "@routes/Videos/utils/types";

type VideoCardProps = {
  /**Video data for the video card.*/
  videoData: FeedVideosItemType;
};

/**
 * Video card that is displayed in videos section
 * https://www.figma.com/design/QCEPjsj7Sdm5KqnY3ta5tq/TEMPLATES--WEB---APP-?node-id=1-12579&t=ixbfRzxxJqi22uhb-4
 */
const VideoCard = ({ videoData }: VideoCardProps): React.ReactElement => {
  const { id, name, urlPath } = videoData;

  const variant: CardVariations = {
    image: {
      position: "",
      width: "w-full",
      isVideo: true,
      playIconPosition: "lower-left",
      aspectRatio: "aspect-video",
    },

    content: {
      width: "w-full",
      extraClass: "pt-2",
    },

    title: {
      color: "text-gray-850",
      size: "text-lg",
      extraClass: "font-lct",
    },
  };

  return (
    <div data-testid="videos-card-component">
      <Card
        id={id}
        link={urlPath}
        title={name}
        variations={variant}
        media={transformMediaToFeedMedia(videoData)}
        className="flex-col"
      />
    </div>
  );
};

export default VideoCard;
